import SettingWrapper from 'modules/settings/components/SettingWrapper';
import MainPage from 'modules/settings/Main';

const UserRoutes = (): any => ({
  path: 'settings',
  element: <SettingWrapper />,
  children: [
    {
      path: '',
      element: <MainPage />,
    },
  ],
});

export default UserRoutes;
